import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { cloneChildren } from '../../_utils';
import { Divider } from '../../divider';
import { Typography } from '../../typography';
import { Menu } from '../menu';
import styles from '../menu.module.scss';
import { MenuVariant } from '../types';

export interface MenuGroupProps {
  /**
   * Valid children to be rendered inside a Men group.
   */
  children?: React.ReactElement[] | React.ReactNode;

  /**
   * Show horizontal divider below the Menu group
   * @default true
   */
  showSeparator?: boolean;

  /**
   * Heading text for the Menu Group.
   */
  headerText?: string;

  /**
   * Variant for Menu.
   * `This is for internal purpose only.` Sent from Menu component.
   * Used to style the component if variant is MenuVariant.SIDE_NAV
   * @default MenuVariant.DEFAULT
   */
  variant?: MenuVariant;

  /**
   * Used to handle keypress callbacks within menu item
   */
  onMenuItemKeyPressCB?: (e: React.KeyboardEvent) => void;
}

export const MenuGroup: React.FC<MenuGroupProps> = ({
  children,
  showSeparator = true,
  headerText,
  variant = MenuVariant.DEFAULT,
  onMenuItemKeyPressCB = _.noop,
}: MenuGroupProps) => {
  return (
    <>
      <div
        className={cx(styles.menuGroupWrapper, {
          [styles.withHeaderText]: !!headerText,
        })}
      >
        {headerText && (
          <div className={styles.groupHeader}>
            <Typography variant="p-bold">{headerText}</Typography>
          </div>
        )}
        {React.Children.toArray(children).map((menuItem: any) => {
          let menuItemProps = {};
          /* Since in select-menu, Typography is also passed as a children to Menu.Group,
                        we need to only send variant prop in case of Menu.Item */
          if (menuItem.type === Menu.Item) {
            menuItemProps = {
              variant,
              keyPressed: onMenuItemKeyPressCB,
            };
          }
          return cloneChildren(menuItem, menuItemProps);
        })}
      </div>
      {children && showSeparator && <Divider />}
    </>
  );
};
